import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TypewriterText from "../components/TypeWriterText";

const pages = [
  { title: "Curator's Foreword", path: "/foreword-islamic-jurisprudence" },
  {
    title: "Day 1: The Definition and General Guidelines for Trade (Bayʿ)",
    path: "/islamic-trade-page-1",
  },
  {
    title: "Day 2: Conditions of a Permissible Trade (shuroot al-bay')",
    path: "/islamic-trade-page-2",
  },
  {
    title: "Day 3: Terms of Trade (shuroot fil-bay')",
    path: "/islamic-trade-page-3",
  },
  {
    title: "Day 4: Right to annul a trade (Khiyār)",
    path: "/islamic-trade-page-4",
  },
  {
    title:
      "Day 5: Prohibition of Disposal, Transfer or Usage before Posession(Nahī an at-Taṣarruf qabla al-Qabḍ)",
    path: "/islamic-trade-page-5",
  },
  {
    title: "Day 6: Prohibition on Usury (Ribā)",
    path: "/islamic-trade-page-6",
  },
  { title: "Day 7: Types of Usury (Ribā)", path: "/islamic-trade-page-7" },
  {
    title: "Day 8: Sale of Land and Attached Assets(Bay' al-Usool wa Thimar)",
    path: "/islamic-trade-page-8",
  },
  {
    title: "Day 9: Paying in Advance for Future Goods(As-Salam)",
    path: "/islamic-trade-page-9",
  },
  {
    title: "Day 10: Rulings concerning Loan(Qard)",
    path: "/islamic-trade-page-10",
  },
  {
    title:
      "Day 11: Types of Items in Loans and The Impact of Inflation on them",
    path: "/islamic-trade-page-11",
  },
  {
    title: "Day 12: Rulings on Mortgage (Rahn)",
    path: "/islamic-trade-page-12",
  },
  {
    title: "Day 13: Rulings on Guarantees (Dhaman) and Patronage (Kafalah)",
    path: "/islamic-trade-page-13",
  },
  {
    title: "Day 14: Rulings on Hawala (Transferance of Debt)",
    path: "/islamic-trade-page-14",
  },
  {
    title: "Day 15: Rulings on Reconciliation (Sulh)",
    path: "/islamic-trade-page-15",
  },
  {
    title: "Day 16: Rulings on Freezing Assets (Hajr)",
    path: "/islamic-trade-page-16",
  },
  {
    title: "Day 17: Financial Transactions by Proxy (Wikalah)",
    path: "/islamic-trade-page-17",
  },
  {
    title: "Day 18: Principles of Partnership (Sharikah) Part 1",
    path: "/islamic-trade-page-18",
  },
  {
    title: "Day 19: Principles of Partnership (Sharikah) Part 2",
    path: "/islamic-trade-page-19",
  },
  {
    title: "Day 20: Rulings on Hiring and Leasing (Ijarah)",
    path: "/islamic-trade-page-20",
  },
  {
    title: "Day 21: Lending for Use Without Gain (Ariyah)",
    path: "/islamic-trade-page-21",
  },
  {
    title: "Day 22: The Pre-Emption Right in Property (Shuf'ah)",
    path: "/islamic-trade-page-22",
  },
  {
    title: "Day 23: Task-Specific Reward Contract (Ja'aalah)",
    path: "/islamic-trade-page-23",
  },
  {
    title: "Day 24: Rulings Pertaining to Endowments (Waqf)",
    path: "/islamic-trade-page-24",
  },
  {
    title: "Day 25: Rulings pertaining Grants (Hibah) and Donations(Atiyah)",
    path: "/islamic-trade-page-25",
  },
];

const IndexPage = () => {
  // State for staggered animation
  const [visibleItems, setVisibleItems] = useState([]);
  // State for hover tracking
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Custom title text for the secondary title
  const titleText = "Islamic Jurispudence on Finance";

  // Staggered animation effect
  useEffect(() => {
    pages.forEach((_, index) => {
      const delay = 50 * index;
      const timeoutId = setTimeout(() => {
        setVisibleItems((prevItems) => [...prevItems, index]);
      }, delay);
      return () => clearTimeout(timeoutId);
    });
  }, []);

  // Define the base style object for all links (matching IndexEconomics)
  const baseLinkStyle = {
    fontSize: "18px",
    width: "100%",
    padding: "15px 20px",
    margin: "0",
    textDecoration: "none",
    borderBottom: "1px solid #eee",
    color: "black",
    cursor: "pointer",
    textAlign: "left",
    transition:
      "color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, opacity 0.5s ease, border-color 0.3s ease",
  };

  // Define the hover style (matching IndexEconomics)
  const hoverStyle = {
    backgroundColor: "#f9f9f9",
    color: "#034d28", // Dark Green text on hover
    transform: "translateX(5px)", // Subtle slide-right effect
    borderBottomColor: "#034d28", // Dark Green border on hover
  };

  return (
    <div
      style={{
        width: "95%",

        margin: "40px auto",
        padding: "0", // Remove padding to allow links to touch edges
        backgroundColor: "white",
        border: "2px solid #ccc",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", //
        fontFamily: "Georgia, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.3px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
          color: "black",
          padding: "0 20px", // Add padding back to the title
        }}
      >
        <b>Table of Contents</b>
        <br />
        <TypewriterText text={titleText} delay={80} />
      </h1>
      {pages.map((page, index) => {
        const isVisible = visibleItems.includes(index);
        const isHovered = hoveredIndex === index;

        return (
          <Link
            key={index}
            to={page.path}
            // Merge base style, animation style, and hover style
            style={{
              ...baseLinkStyle,
              // Animation style (fade in and slide up)
              ...(isVisible
                ? {}
                : { opacity: 0, transform: "translateY(20px)" }),
              // Hover style
              ...(isHovered ? hoverStyle : {}),
            }}
            // Hover handlers
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {page.title}
          </Link>
        );
      })}
    </div>
  );
};

export default IndexPage;
